import { onIdle } from '@shared/fondof-fn/promise/idle'
import { useCustomerStore } from '@shared/global-store/stores/customer/customer'
import { useWishlistStore } from '@shared/global-store/stores/wishlist/wishlist'
import {
  addWishlistToCustomer,
  getCustomerWishlists,
  getWishlistById,
  removeStaleWishlistItems,
} from '@shared/shop-api/wishlist/api'

import { trackError } from '@fond-of/telemetry'

export const bootstrapWishlistSSR = async () => {
  const wishlistStore = useWishlistStore()
  const customerStore = useCustomerStore()

  if (!customerStore.token || wishlistStore.itemCount > 0) {
    return
  }

  try {
    const wishlists = await getCustomerWishlists()

    wishlistStore.setWishlists(wishlists)

    if (!wishlists.length) {
      const wishlist = await addWishlistToCustomer(wishlists)

      if (!wishlist) {
        console.warn(
          '[Wishlist] Could not create a wishlist. Make sure the "custom.wishlists" metafield definition (type: json) exists for the Customer resource in your Shopify admin.'
        )
        return
      }

      wishlistStore.setWishlist(wishlist)
      return
    }

    // If in future multiple wishlists are supported, we need to select which one to use here,
    // for now we just take the first one, cause multiple wishlists are not supported in the UI
    const wishlist = await getWishlistById(wishlists, wishlists[0].id)

    if (!wishlist) {
      return
    }

    wishlistStore.setWishlist(wishlist)
  } catch (error) {
    trackError(error)
  }
}

export const bootstrapWishlistClient = async () => {
  const wishlistStore = useWishlistStore()

  onIdle(async () => {
    if (!wishlistStore.wishlist) {
      return
    }

    await removeStaleWishlistItems(
      wishlistStore.wishlists,
      wishlistStore.wishlist
    )
  })
}
